import { render } from "./AddUser.vue?vue&type=template&id=6f1a5f8a&scoped=true&ts=true"
import script from "./AddUser.vue?vue&type=script&lang=ts"
export * from "./AddUser.vue?vue&type=script&lang=ts"

import "./AddUser.vue?vue&type=style&index=0&id=6f1a5f8a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f1a5f8a"]])

export default __exports__